import { render, staticRenderFns } from "./ListaPaquetesDirectorio.vue?vue&type=template&id=6690bd44"
import script from "./ListaPaquetesDirectorio.vue?vue&type=script&lang=js"
export * from "./ListaPaquetesDirectorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports